import { render } from "./SiteMsg.vue?vue&type=template&id=57184b6e&scoped=true"
import script from "./SiteMsg.vue?vue&type=script&lang=js"
export * from "./SiteMsg.vue?vue&type=script&lang=js"

import "./SiteMsg.vue?vue&type=style&index=0&id=57184b6e&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57184b6e"]])

export default __exports__